import { FC } from 'react'
import { useHistory } from 'react-router'
import { Trans } from 'react-i18next'
import PerFlexRow from '../../../components/custom_components/FlexRow'
import PerIcon from '../../../components/custom_components/Icon'
import PerText from '../../../components/custom_components/Text'

type DashboardAppraisalMonitoringFooterProps = {
  hiddenUpdatesCount: number
}

const DashboardAppraisalMonitoringFooter: FC<DashboardAppraisalMonitoringFooterProps> = ({ hiddenUpdatesCount }) => {
  const history = useHistory()

  return (
    <PerFlexRow justify="space-between" align="middle" className="dashboard-appraisal-monitoring__footer">
      <PerFlexRow align="middle">
        <PerIcon name="dashboard_footerWarning" color="secondary" size={17} />
        <PerText color="secondary" fontSize="s" ml="xxxs">
          <Trans
            i18nKey={
              hiddenUpdatesCount === 1
                ? 'dashboard.companyManager.monitoring.footer.textWithCount1'
                : 'dashboard.companyManager.monitoring.footer.text'
            }
            values={{ count: hiddenUpdatesCount }}
            components={[<strong />]}
          />
        </PerText>
      </PerFlexRow>
      <PerText fontSize="s" fontWeight="bold">
        <Trans
          i18nKey="dashboard.companyManager.monitoring.footer.cta"
          components={[
            <a
              key="your-company-link"
              onClick={(e) => {
                e.preventDefault()
                history.push('/your-company')
              }}
              style={{ color: '#05cbce', textDecoration: 'underline', cursor: 'pointer' }}
            />,
          ]}
        />
      </PerText>
    </PerFlexRow>
  )
}

export default DashboardAppraisalMonitoringFooter
